export const createLocalStorage = (): Storage => {
  if (typeof window === "undefined") {
    return {
      clear: () => null,
      getItem: () => null,
      key: () => null,
      length: 0,
      removeItem: () => null,
      setItem: () => null,
    };
  }

  return window.localStorage;
};
